<div class="dialog-container">
  <div>
    <h2 class="feedback-heading">Send feedback</h2>
    <p class="feedback-subtitle">
      Tell us what's wrong or what could be better.
    </p>
    <div *ngIf="!submitted; else success">
      <form
        *ngIf="!loading; else loadingSpinner"
        class="form-container"
        [formGroup]="feedbackForm"
        class="w-100"
      >
        <!-- Context preview — visible only when opened from a result with
             something concrete to show. Read-only, rendered so the user can
             see what we'll forward alongside their message. -->
        <div *ngIf="context && (context.registration || context.term)"
             class="border rounded p-2 mb-3" style="background: #f5f7f8;">
          <p class="mb-1 text-muted" style="font-size: 12px;">Reporting from:</p>
          <p class="mb-0" style="font-size: 13px;">
            <span *ngIf="context.registration"><strong>{{ context.registration }}</strong></span>
            <span *ngIf="context.term"> &middot; term <em>{{ context.term }}</em></span>
          </p>
        </div>

        <!-- Honeypot — hidden from real users, must stay empty. -->
        <input
          type="text"
          formControlName="website"
          name="website"
          autocomplete="off"
          tabindex="-1"
          aria-hidden="true"
          style="position: absolute; left: -9999px; width: 1px; height: 1px; opacity: 0;"
        />

        <mat-form-field
          appearance="outline"
          class="w-100 d-block mb-3"
          *ngIf="!fetching"
        >
          <input
            matInput
            formControlName="email"
            placeholder="Email (optional — only if you'd like a reply)"
            name="email"
            type="email"
          />
          <mat-error *ngIf="feedbackForm.controls.email.hasError('email')">
            Please enter a valid email address
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100 d-block mb-2">
          <textarea
            matInput
            required
            formControlName="summary"
            placeholder="Feedback"
            name="summary"
          ></textarea>
          <mat-error *ngIf="feedbackForm.controls.summary.hasError('required')">
            Feedback is <strong>required</strong>
          </mat-error>
        </mat-form-field>

        <button
          mat-flat-button
          class="turquoise-button w-100"
          (click)="submit()"
        >
          Submit
        </button>

        <button
          mat-stroked-button
          class="w-100 mt-1"
          [color]="'warn'"
          mat-dialog-close
        >
          Cancel
        </button>

        <p *ngIf="error">{{ error }}</p>
      </form>
    </div>
    <ng-template #success>
      <div class="text-center border-top pt-3">
        <h2 class="mb-0">Thank you!</h2>
        <p>We appreciate your feedback</p>
      </div>
    </ng-template>
  </div>
</div>

<ng-template #loadingSpinner>
  <div class="full spinner-loader">
    <div>
      <mat-progress-spinner
        class="spinner cyan"
        mode="indeterminate"
        [color]="'#327b8d'"
        [diameter]="60"
      ></mat-progress-spinner>
    </div>
    <span>Sending Feedback...</span>
  </div>
</ng-template>
